module.exports = __webpack_public_path__ + "static/media/chatbot.6fb9732c.svg";